import { accessRouteChain } from './access-route-chain.js';
import type { AccessRoute } from './route-access.js';
import { routeRequiresBrandMembership } from './route-requires-brand-membership.js';

export type MissingRouteAccess = {
  missingPermissions: string[];
  needsBrandMembership: boolean;
};

/** What keeps a person out of a route; both empty means they can open it. */
export function missingRouteAccess(
  route: AccessRoute,
  {
    permissions,
    hasActiveBrandMembership,
  }: Readonly<{ permissions: readonly string[]; hasActiveBrandMembership: boolean }>,
): MissingRouteAccess {
  const holds = (permission: string) => permissions.includes(permission);
  const required = accessRouteChain(route).flatMap((entry) =>
    entry.admitsAnyOf?.some(holds) ? [] : (entry.required ?? []),
  );
  return {
    missingPermissions: [...new Set(required)].filter((permission) => !holds(permission)),
    needsBrandMembership: routeRequiresBrandMembership(route) && !hasActiveBrandMembership,
  };
}
